<template>
    <div class="engineering">
        <el-container>
            <el-header>
                <el-form class="engineeringForm" :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="queryBtn()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.importDetailedData.btnEnable"
                                    type="primary"
                                    @click="handleShowDataUploadDialogClick()"
                            >细目数据导入</el-button>
                            <el-button
                                    v-if="btnAuthorize.deleteDetailedData.btnEnable"
                                    type="primary"
                                    @click="handleSelectDeleteClick()"
                            >删除总包细目</el-button>
                            <el-button
                                    v-if="btnAuthorize.batchSubApproval.btnEnable"
                                    type="primary"
                                    @click="handleSelectSubmitClick()"
                            >批量提交审批</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                            <el-button
                                    v-if="btnAuthorize.setTabHiddenVisible.btnEnable"
                                    type="primary"
                                    @click="setTabDialogBtn()"
                            >设置Tab显隐</el-button>
                            <!--                            <el-button-->
                            <!--                                    v-if="btnAuthorize.allSave.btnEnable"-->
                            <!--                                    style="margin-top: 10px;margin-left: 0px"-->
                            <!--                                    type="primary"-->
                            <!--                                    @click="handleAllSaveClick()"-->
                            <!--                            >批量暂存</el-button>-->
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <div class="statisticsList" v-if="listTotal">
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">合同合计</div>
                                    <div class="statisticsNum">{{listTotal.contractSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">核实合计</div>
                                    <div class="statisticsNum">{{listTotal.checkSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际完成产值</div>
                                    <div class="statisticsNum">{{listTotal.actFinishProduction}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">预计成本合计</div>
                                    <div class="statisticsNum">{{listTotal.expectCostPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">预计-劳务</div>
                                    <div class="statisticsNum">{{listTotal.laborPlanSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">预计-材料</div>
                                    <div class="statisticsNum">{{listTotal.materialPlanSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">预计-机械</div>
                                    <div class="statisticsNum">{{listTotal.machinePlanSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">预计-其他</div>
                                    <div class="statisticsNum">{{listTotal.otherPlanSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际成本合计</div>
                                    <div class="statisticsNum">{{listTotal.actCostPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际-劳务</div>
                                    <div class="statisticsNum">{{listTotal.laborActSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际-材料</div>
                                    <div class="statisticsNum">{{listTotal.materialActSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际-机械</div>
                                    <div class="statisticsNum">{{listTotal.machineActSumPrice}}</div>
                                </div>
                                <div class="statisticsItem">
                                    <div class="statisticsTxt">实际-其他</div>
                                    <div class="statisticsNum">{{listTotal.otherActSumPrice}}</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        v-loading="loading"
                        element-loading-background="transparent"
                        class="bueatyScroll"
                        ref="dataTable"
                        :data="engineerList"
                        :span-method="spanArrayMethod"
                        @select="selectCheckOne"
                        @select-all="selectAll"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column
                            type="selection"
                            :key="-1"
                            width="55">
                    </el-table-column>
                    <el-table-column :fixed="true" label="细目信息（总包）" width="160px" :key="-2"
                                     :show-overflow-tooltip="true">
                        <el-table-column fixed="left" width="80px" prop="subCategoryName" label="细目名称" :key="-3"></el-table-column>
                        <el-table-column fixed="left" width="80px" prop="subCategoryNo" label="细目号" :key="-4"
                                         :show-overflow-tooltip="true"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="projectName" label="清单（总包）" v-if="selectTabList.indexOf(1) != -1" :key="1"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="deptName" label="价格" v-if="selectTabList.indexOf(2) != -1" :key="2"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="unit" label="单位" width="150px" v-if="selectTabList.indexOf(3) != -1" :key="3">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.unit" @blur="setValue(scope.row,1,'unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unitPrice" label="单价" width="150px" v-if="selectTabList.indexOf(4) != -1" :key="4">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.unitPrice" @blur="setValue(scope.row,1,'unitPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unitPriceTypeBool" label="是否正式单价" width="150px" v-if="selectTabList.indexOf(133) != -1" :key="133">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.unitPriceTypeBool"
                                                 @change="setValue(scope.row,1,'unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合同" v-if="selectTabList.indexOf(5) != -1" :key="5"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="contractCount" label="合同数量" width="150px" v-if="selectTabList.indexOf(6) != -1" :key="6">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.contractCount" @blur="setValue(scope.row,1,'contractCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contractSumPrice" label="合同合价" v-if="selectTabList.indexOf(7) != -1" :key="7"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="核实" v-if="selectTabList.indexOf(8) != -1" :key="8"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="checkCount" label="核实数量" width="150px" v-if="selectTabList.indexOf(9) != -1" :key="9">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.checkCount" @blur="setValue(scope.row,1,'checkCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="checkSumPrice" label="核实合价" v-if="selectTabList.indexOf(10) != -1" :key="10"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="计量数量" v-if="selectTabList.indexOf(11) != -1" :key="11"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="expectCount" label="数量" width="150px" v-if="selectTabList.indexOf(12) != -1" :key="12">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.expectCount" @blur="setValue(scope.row,1,'expectCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="expectSumPrice" label="合价" v-if="selectTabList.indexOf(13) != -1" :key="13"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="实际完成数量" v-if="selectTabList.indexOf(14) != -1" :key="14"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="actFinishCount" label="数量" width="150px" v-if="selectTabList.indexOf(15) != -1" :key="15">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.actFinishCount" @blur="setValue(scope.row,1,'actFinishCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actFinishSumPrice" label="合价" v-if="selectTabList.indexOf(16) != -1" :key="16"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="计划完成数量" v-if="selectTabList.indexOf(17) != -1" :key="17"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="expectFinishCount" label="数量" width="150px" v-if="selectTabList.indexOf(18) != -1" :key="18"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.expectFinishCount" @blur="setValue(scope.row,1,'expectFinishCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="expectFinishSumPrice" label="合价" v-if="selectTabList.indexOf(19) != -1" :key="19"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="预计成本" v-if="selectTabList.indexOf(20) != -1" :key="20"
                                     :show-overflow-tooltip="true">
                        <el-table-column label="劳务" v-if="selectTabList.indexOf(21) != -1" :key="21"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="laborItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(22) != -1" :key="22"
                                             width="150px"></el-table-column>
                            <el-table-column prop="laborItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(23) != -1" :key="23"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(24) != -1" :key="24">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unit" @blur="setValue(scope.row,2,'laborItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="laborItem_unitPrice" v-if="selectTabList.indexOf(25) != -1" :key="25">
                                <!--                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.laborItem_unitPrice" @blur="setValue(scope.row,2)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(26) != -1" :key="26">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.laborItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.laborItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,2,'laborItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(27) != -1" :key="27">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_taxRate" @blur="setValue(scope.row,2,'laborItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(28) != -1" :key="28">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_bidPrice" @blur="setValue(scope.row,2,'laborItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(29) != -1" :key="29">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unitCount" @blur="setValue(scope.row,2,'laborItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laborItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(30) != -1" :key="30"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="laborItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(31) != -1" :key="31"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(32) != -1" :key="32">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_remark"  @blur="setValue(scope.row,2,'laborItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="材料" v-if="selectTabList.indexOf(33) != -1" :key="33"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="materialItem_productName" label="存货名称" v-if="selectTabList.indexOf(34) != -1" :key="34"
                                             width="150px"></el-table-column>
                            <el-table-column prop="materialItem_productNumber" label="存货编码" v-if="selectTabList.indexOf(35) != -1" :key="35"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_model" label="规格类型" v-if="selectTabList.indexOf(36) != -1" :key="36"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(37) != -1" :key="37">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unit" @blur="setValue(scope.row,3,'materialItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="materialItem_unitPrice" v-if="selectTabList.indexOf(38) != -1" :key="38">
                                <!--                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.materialItem_unitPrice" @blur="setValue(scope.row,3)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(39) != -1" :key="39">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-checkbox v-model="scope.row.materialItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.materialItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,3,'materialItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(40) != -1" :key="40">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_taxRate" @blur="setValue(scope.row,3,'materialItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(41) != -1" :key="41">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_bidPrice" @blur="setValue(scope.row,3,'materialItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(42) != -1" :key="42">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unitCount" @blur="setValue(scope.row,3,'materialItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(43) != -1" :key="43"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(44) != -1" :key="44"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(45) != -1" :key="45">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_remark" @blur="setValue(scope.row,3,'materialItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="机械" v-if="selectTabList.indexOf(46) != -1" :key="46"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="machineItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(47) != -1" :key="47"
                                             width="150px"></el-table-column>
                            <el-table-column prop="machineItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(48) != -1" :key="48"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(49) != -1" :key="49">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unit" @blur="setValue(scope.row,4,'machineItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="machineItem_unitPrice" v-if="selectTabList.indexOf(50) != -1" :key="50">
                                <!--                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.machineItem_unitPrice" @blur="setValue(scope.row,4)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(51) != -1" :key="51">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.machineItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.machineItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,4,'machineItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(52) != -1" :key="52">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_taxRate" @blur="setValue(scope.row,4,'machineItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(53) != -1" :key="53">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_bidPrice" @blur="setValue(scope.row,4,'machineItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(54) != -1" :key="54">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unitCount" @blur="setValue(scope.row,4,'machineItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="machineItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(55) != -1" :key="55"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="machineItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(56) != -1" :key="56"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(57) != -1" :key="57">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_remark" @blur="setValue(scope.row,4,'machineItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="其他" v-if="selectTabList.indexOf(58) != -1" :key="58"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="otherItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(59) != -1" :key="59"
                                             width="150px"></el-table-column>
                            <el-table-column prop="otherItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(60) != -1" :key="60"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(61) != -1" :key="61">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unit" @blur="setValue(scope.row,5,'otherItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="otherItem_unitPrice" v-if="selectTabList.indexOf(62) != -1" :key="62">
                                <!--                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.otherItem_unitPrice" @blur="setValue(scope.row,5)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(63) != -1" :key="63">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.otherItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.otherItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,5,'otherItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(64) != -1" :key="64">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_taxRate" @blur="setValue(scope.row,5,'otherItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(65) != -1" :key="65">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_bidPrice" @blur="setValue(scope.row,5,'otherItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(66) != -1" :key="66">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unitCount" @blur="setValue(scope.row,5,'otherItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="otherItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(67) != -1" :key="67"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="otherItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(68) != -1" :key="68"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(69) != -1" :key="69">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_remark" @blur="setValue(scope.row,5,'otherItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合计" v-if="selectTabList.indexOf(70) != -1" :key="70"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="unit_Price" label="单价" v-if="selectTabList.indexOf(71) != -1" :key="71"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="total_Price" label="合计" v-if="selectTabList.indexOf(72) != -1" :key="72"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="bidSum_Price" label="中标裸税合价" v-if="selectTabList.indexOf(73) != -1" :key="73"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="实际支出" v-if="selectTabList.indexOf(74) != -1" :key="74"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="partyBName" label="合作单位" v-if="selectTabList.indexOf(75) != -1" :key="75">
<!--                            <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">-->
<!--                                <span>{{scope.row.partyBName}}</span>-->
<!--                            </template>-->
                        </el-table-column>
                        <el-table-column prop="scope.deptName" label="劳务" v-if="selectTabList.indexOf(76) != -1" :key="76"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowLaborItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(77) != -1" :key="77"
                                             width="150px"></el-table-column>
                            <el-table-column prop="nowLaborItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(78) != -1" :key="78"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(79) != -1" :key="79">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_unit" @blur="setValue(scope.row,6,'nowLaborItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="nowLaborItem_unitPrice" v-if="selectTabList.indexOf(80) != -1" :key="80">
                                <!--                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.nowLaborItem_unitPrice" @blur="setValue(scope.row,6)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(81) != -1" :key="81">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowLaborItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.nowLaborItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,6,'nowLaborItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(82) != -1" :key="82">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_taxRate" @blur="setValue(scope.row,6,'nowLaborItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(83) != -1" :key="83">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_bidPrice" @blur="setValue(scope.row,6,'nowLaborItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(84) != -1" :key="84">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_unitCount" @blur="setValue(scope.row,6,'nowLaborItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowLaborItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(85) != -1" :key="85"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowLaborItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(86) != -1" :key="86"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(87) != -1" :key="87">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_remark" @blur="setValue(scope.row,6,'nowLaborItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="partyBName" label="合作单位" v-if="selectTabList.indexOf(88) != -1" :key="88">
<!--                            <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">-->
<!--                                <span>{{scope.row.partyBName}}</span>-->
<!--                            </template>-->
                        </el-table-column>
                        <el-table-column label="材料" v-if="selectTabList.indexOf(89) != -1" :key="89"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowMaterialItem_productName" label="存货名称" v-if="selectTabList.indexOf(90) != -1" :key="90"
                                             width="150px"></el-table-column>
                            <el-table-column prop="nowMaterialItem_productNumber" label="存货编码" v-if="selectTabList.indexOf(91) != -1" :key="91"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_model" label="规格类型" v-if="selectTabList.indexOf(92) != -1" :key="92"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(93) != -1" :key="93">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_unit" @blur="setValue(scope.row,7,'nowMaterialItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="nowMaterialItem_unitPrice" v-if="selectTabList.indexOf(94) != -1" :key="94">
                                <!--                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_unitPrice" @blur="setValue(scope.row,7)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(95) != -1" :key="95">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-checkbox v-model="scope.row.nowMaterialItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.nowMaterialItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,7,'nowMaterialItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(96) != -1" :key="96">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_taxRate" @blur="setValue(scope.row,7,'nowMaterialItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(97) != -1" :key="97">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_bidPrice" @blur="setValue(scope.row,7,'nowMaterialItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(98) != -1" :key="98">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_unitCount" @blur="setValue(scope.row,7,'nowMaterialItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowMaterialItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(99) != -1" :key="99"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(100) != -1" :key="100"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(101) != -1" :key="101">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_remark" @blur="setValue(scope.row,7,'nowMaterialItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="partyBName" label="合作单位" v-if="selectTabList.indexOf(102) != -1" :key="102">
<!--                            <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">-->
<!--                                <span>{{scope.row.partyBName}}</span>-->
<!--                            </template>-->
                        </el-table-column>
                        <el-table-column label="机械" v-if="selectTabList.indexOf(103) != -1" :key="103"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowMachineItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(104) != -1" :key="104"
                                             width="150px"></el-table-column>
                            <el-table-column prop="nowMachineItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(105) != -1" :key="105"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(106) != -1" :key="106">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_unit" @blur="setValue(scope.row,8,'nowMachineItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="nowMachineItem_unitPrice" v-if="selectTabList.indexOf(107) != -1" :key="107">
                                <!--                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.nowMachineItem_unitPrice" @blur="setValue(scope.row,8)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(108) != -1" :key="108">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowMachineItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.nowMachineItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,8,'nowMachineItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(109) != -1" :key="109">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_taxRate" @blur="setValue(scope.row,8,'nowMachineItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(110) != -1" :key="110">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_bidPrice" @blur="setValue(scope.row,8,'nowMachineItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(111) != -1" :key="111">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_unitCount" @blur="setValue(scope.row,8,'nowMachineItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowMachineItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(112) != -1" :key="112"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMachineItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(113) != -1" :key="113"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(114) != -1" :key="114">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_remark" @blur="setValue(scope.row,8,'nowMachineItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="partyBName" label="合作单位" v-if="selectTabList.indexOf(115) != -1" :key="115">
<!--                            <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">-->
<!--                                <span>{{scope.row.partyBName}}</span>-->
<!--                            </template>-->
                        </el-table-column>
                        <el-table-column label="其他" v-if="selectTabList.indexOf(116) != -1" :key="116"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowOtherItem_subCategoryName" label="细目名称" v-if="selectTabList.indexOf(117) != -1" :key="117"
                                             width="150px"></el-table-column>
                            <el-table-column prop="nowOtherItem_subCategoryNo" label="细目号" v-if="selectTabList.indexOf(118) != -1" :key="118"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单位" width="150px" v-if="selectTabList.indexOf(119) != -1" :key="119">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_unit" @blur="setValue(scope.row,9,'nowOtherItem_unit')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="150px" prop="nowOtherItem_unitPrice" v-if="selectTabList.indexOf(120) != -1" :key="120">
                                <!--                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">-->
                                <!--                                    <el-input size="mini" v-model="scope.row.nowOtherItem_unitPrice" @blur="setValue(scope.row,9)"></el-input>-->
                                <!--                                </template>-->
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px" v-if="selectTabList.indexOf(121) != -1" :key="121">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowOtherItem_unitPriceTypeBool" style="z-index: 0"
                                                 :checked="scope.row.nowOtherItem_unitPriceTypeBool"
                                                 @change="setValue(scope.row,9,'nowOtherItem_unitPriceTypeBool')">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率（%）" width="150px" v-if="selectTabList.indexOf(122) != -1" :key="122">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_taxRate" @blur="setValue(scope.row,9,'nowOtherItem_taxRate')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px" v-if="selectTabList.indexOf(123) != -1" :key="123">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_bidPrice" @blur="setValue(scope.row,9,'nowOtherItem_bidPrice')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px" v-if="selectTabList.indexOf(124) != -1" :key="124">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_unitCount" @blur="setValue(scope.row,9,'nowOtherItem_unitCount')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowOtherItem_unitSumPrice" label="合价" v-if="selectTabList.indexOf(125) != -1" :key="125"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowOtherItem_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(126) != -1" :key="126"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                            <el-table-column label="备注" width="150px" v-if="selectTabList.indexOf(127) != -1" :key="127">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_remark" @blur="setValue(scope.row,9,'nowOtherItem_remark')"></el-input>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <!-- <el-table-column prop="deptName" label="合计" v-if="selectTabList.indexOf(128) != -1" :key="128"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="party_unitPrice" label="单价" v-if="selectTabList.indexOf(129) != -1" :key="129"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="party_unitSumPrice" label="合计" v-if="selectTabList.indexOf(130) != -1" :key="130"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="party_bidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(131) != -1" :key="131"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                        </el-table-column> -->
                         <el-table-column prop="deptName" label="合计" v-if="selectTabList.indexOf(128) != -1" :key="128"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="totalUnitPrice" label="单价" v-if="selectTabList.indexOf(129) != -1" :key="129"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="totalUnitSumPrice" label="合计" v-if="selectTabList.indexOf(130) != -1" :key="130"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="totalBidSumPrice" label="中标裸税合价" v-if="selectTabList.indexOf(131) != -1" :key="131"
                                             :show-overflow-tooltip="true" width="150px"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="approveStatusShow" label="审核状态" v-if="selectTabList.indexOf(132) != -1" :key="132"
                                     :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作" prop="operation" fixed="right"  min-width="250px" :key="-5">
                        <template slot-scope="scope">
                            <el-button @click="handleAddBillClick(scope.row)" type="text" size="small">新增工程量清单</el-button>
                            <el-button @click="handleAddDetailClick(scope.row, 1)" type="text" size="small">新增细目（预计）</el-button>
                            <el-button @click="handleAddDetailClick(scope.row, 2)" type="text" size="small">新增细目（实际）</el-button>
                            <el-button @click="handleDeleteClick(scope.row)" type="text" size="small">删除细目</el-button>
                            <!--                            <el-button @click="handleSaveClick(scope.row)" type="text" size="small">暂存</el-button>-->
                            <el-button @click="handleSubmitClick(scope.row)" type="text" size="small">提交审核</el-button>
                            <el-button @click="handleWithdrawClick(scope.row)" type="text" size="small">撤回</el-button>
                            <el-button @click="handleHistoryEditionClick(scope.row)" type="text" size="small">历史版本</el-button>
                            <el-button @click="handleInfoDetailsClick(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>

        <add-detail v-if="addVisible" :projectId="dataForm.projectId" ref="addDetail" @refreshDataList="query"></add-detail>
        <add-bill v-if="addBillVisible" ref="addBillDetail" @refreshDataList="query"></add-bill>
        <add-unit v-if="addUnitVisible" ref="addUnit" @refreshDataList="getProjectList"></add-unit>
        <submit-review v-if="submitVisible" ref="submitReview" @refreshDataList="query"></submit-review>
        <all-submit-review v-if="allSubmitVisible" ref="allSubmitReview" @refreshDataList="initData"></all-submit-review>
        <tab-show-dialog v-if="isShowTabDialog" ref="tabShowDialog" :title="'事中Tab显隐'" @setSelectTabList="setSelectTabList"></tab-show-dialog>
        <data-upload-dialog v-if="isShowDataUploadDialog" ref="dataUploadDialog" @refreshDataList="uploadData"></data-upload-dialog>
    </div>
</template>

<script>
    import {inTheSpanMethod, getJBXXTableData} from '../spanMethod';
    import { inTheModifyValue } from '../modifyValue';
    import addDetail from './add-detail'
    import addBill from './add-bill'
    import addUnit from './add-unit'
    import dataUploadDialog from './data-upload-dialog'
    import submitReview from '../submit-review'
    import allSubmitReview from '../all-submit-review'
    import tabShowDialog from '../tabShowDialog'
    import {
        getProjectListService,
    } from '@/services/invoiceServices'
    import {
        getDeptListService,
        queryMiddleListService,
        getMiddleListTotalService,
        exportMiddleService,
        saveMiddleService,
        saveMiddleBatchService,
        recallApproveProcessService,
        batchDeleteMiddleDataService,
    } from "../../../services/engineering";
    import {exportExcelService2} from "../../../services/allContractServices";
    import { Loading } from 'element-ui';
    export default {
        name: "index",
        data(){
            return {
                checked: false,
                dataForm:{
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,

                tabDataList:[{
                    label: '事中成本',
                    id: 0,
                    children:[
                        {
                            label: '清单（总包）',
                            id: 1,
                            children: [
                                {
                                    label: '价格',
                                    id: 2,
                                    children: [{
                                        label: '单位',
                                        id: 3,
                                    },{
                                        label: '单价',
                                        id: 4,
                                    },{
                                        label: '是否正式单价',
                                        id: 133,
                                    },]
                                },{
                                    label: '合同',
                                    id: 5,
                                    children: [{
                                        label: '合同数量',
                                        id: 6,
                                    },{
                                        label: '合同合价',
                                        id: 7,
                                    },]
                                },{
                                    label: '核实',
                                    id: 8,
                                    children: [{
                                        label: '核实数量',
                                        id: 9,
                                    },{
                                        label: '核实合价',
                                        id: 10,
                                    },]
                                },
                                {
                                    label: '计量数量',
                                    id: 11,
                                    children: [{
                                        label: '数量',
                                        id: 12,
                                    },{
                                        label: '合价',
                                        id: 13,
                                    },]
                                },
                                {
                                    label: '实际完成数量',
                                    id: 14,
                                    children: [{
                                        label: '数量',
                                        id: 15,
                                    },{
                                        label: '合价',
                                        id: 16,
                                    },]
                                },
                                {
                                    label: '计划完成数量',
                                    id: 17,
                                    children: [{
                                        label: '数量',
                                        id: 18,
                                    },{
                                        label: '合价',
                                        id: 19,
                                    },]
                                }
                            ],
                        },{
                            label: '预计成本',
                            id: 20,
                            children: [
                                {
                                    label: '劳务',
                                    id: 21,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 22,
                                        },{
                                            label: '细目号',
                                            id: 23,
                                        },{
                                            label: '单位',
                                            id: 24,
                                        },{
                                            label: '单价',
                                            id: 25,
                                        },{
                                            label: '是否正式单价',
                                            id: 26,
                                        },{
                                            label: '税率（%）',
                                            id: 27,
                                        },{
                                            label: '中标裸税单价',
                                            id: 28,
                                        },{
                                            label: '数量',
                                            id: 29,
                                        },{
                                            label: '合价',
                                            id: 30,
                                        },{
                                            label: '中标裸税合价',
                                            id: 31,
                                        },{
                                            label: '备注',
                                            id: 32,
                                        },
                                    ]
                                },
                                {
                                    label: '材料',
                                    id: 33,
                                    children: [
                                        {
                                            label: '存货名称',
                                            id: 34,
                                        },{
                                            label: '存货编码',
                                            id: 35,
                                        },{
                                            label: '规格类型',
                                            id: 36,
                                        },{
                                            label: '单位',
                                            id: 37,
                                        },{
                                            label: '单价',
                                            id: 38,
                                        },{
                                            label: '是否正式单价',
                                            id: 39,
                                        },{
                                            label: '税率（%）',
                                            id: 40,
                                        },{
                                            label: '中标裸税单价',
                                            id: 41,
                                        },{
                                            label: '数量',
                                            id: 42,
                                        },{
                                            label: '合价',
                                            id: 43,
                                        },{
                                            label: '中标裸税合价',
                                            id: 44,
                                        },{
                                            label: '备注',
                                            id: 45,
                                        },
                                    ]
                                },{
                                    label: '机械',
                                    id: 46,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 47,
                                        },{
                                            label: '细目号',
                                            id: 48,
                                        },{
                                            label: '单位',
                                            id: 49,
                                        },{
                                            label: '单价',
                                            id: 50,
                                        },{
                                            label: '是否正式单价',
                                            id: 51,
                                        },{
                                            label: '税率（%）',
                                            id: 52,
                                        },{
                                            label: '中标裸税单价',
                                            id: 53,
                                        },{
                                            label: '数量',
                                            id: 54,
                                        },{
                                            label: '合价',
                                            id: 55,
                                        },{
                                            label: '中标裸税合价',
                                            id: 56,
                                        },{
                                            label: '备注',
                                            id: 57,
                                        },
                                    ]
                                },{
                                    label: '其他',
                                    id: 58,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 59,
                                        },{
                                            label: '细目号',
                                            id: 60,
                                        },{
                                            label: '单位',
                                            id: 61,
                                        },{
                                            label: '单价',
                                            id: 62,
                                        },{
                                            label: '是否正式单价',
                                            id: 63,
                                        },{
                                            label: '税率（%）',
                                            id: 64,
                                        },{
                                            label: '中标裸税单价',
                                            id: 65,
                                        },{
                                            label: '数量',
                                            id: 66,
                                        },{
                                            label: '合价',
                                            id: 67,
                                        },{
                                            label: '中标裸税合价',
                                            id: 68,
                                        },{
                                            label: '备注',
                                            id: 69,
                                        },
                                    ]
                                },{
                                    label: '合计',
                                    id: 70,
                                    children: [
                                        {
                                            label: '单价',
                                            id: 71,
                                        },{
                                            label: '合计',
                                            id: 72,
                                        },{
                                            label: '中标裸税合价',
                                            id: 73,
                                        }
                                    ]
                                }
                            ],
                        },{
                            label: '实际支出',
                            id: 74,
                            children: [
                                {
                                    label: '合作单位',
                                    id: 75,
                                },
                                {
                                    label: '劳务',
                                    id: 76,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 77,
                                        },{
                                            label: '细目号',
                                            id: 78,
                                        },{
                                            label: '单位',
                                            id: 79,
                                        },{
                                            label: '单价',
                                            id: 80,
                                        },{
                                            label: '是否正式单价',
                                            id: 81,
                                        },{
                                            label: '税率（%）',
                                            id: 82,
                                        },{
                                            label: '中标裸税单价',
                                            id: 83,
                                        },{
                                            label: '数量',
                                            id: 84,
                                        },{
                                            label: '合价',
                                            id: 85,
                                        },{
                                            label: '中标裸税合价',
                                            id: 86,
                                        },{
                                            label: '备注',
                                            id: 87,
                                        },
                                    ]
                                },
                                {
                                    label: '合作单位',
                                    id: 88,
                                },
                                {
                                    label: '材料',
                                    id: 89,
                                    children: [
                                        {
                                            label: '存货名称',
                                            id: 90,
                                        },{
                                            label: '存货编码',
                                            id: 91,
                                        },{
                                            label: '规格类型',
                                            id: 92,
                                        },{
                                            label: '单位',
                                            id: 93,
                                        },{
                                            label: '单价',
                                            id: 94,
                                        },{
                                            label: '是否正式单价',
                                            id: 95,
                                        },{
                                            label: '税率（%）',
                                            id: 96,
                                        },{
                                            label: '中标裸税单价',
                                            id: 97,
                                        },{
                                            label: '数量',
                                            id: 98,
                                        },{
                                            label: '合价',
                                            id: 99,
                                        },{
                                            label: '中标裸税合价',
                                            id: 100,
                                        },{
                                            label: '备注',
                                            id: 101,
                                        },
                                    ]
                                },
                                {
                                    label: '合作单位',
                                    id: 102,
                                },
                                {
                                    label: '机械',
                                    id: 103,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 104,
                                        },{
                                            label: '细目号',
                                            id: 105,
                                        },{
                                            label: '单位',
                                            id: 106,
                                        },{
                                            label: '单价',
                                            id: 107,
                                        },{
                                            label: '是否正式单价',
                                            id: 108,
                                        },{
                                            label: '税率（%）',
                                            id: 109,
                                        },{
                                            label: '中标裸税单价',
                                            id: 110,
                                        },{
                                            label: '数量',
                                            id: 111,
                                        },{
                                            label: '合价',
                                            id: 112,
                                        },{
                                            label: '中标裸税合价',
                                            id: 113,
                                        },{
                                            label: '备注',
                                            id: 114,
                                        },
                                    ]
                                },
                                {
                                    label: '合作单位',
                                    id: 115,
                                },
                                {
                                    label: '其他',
                                    id: 116,
                                    children: [
                                        {
                                            label: '细目名称',
                                            id: 117,
                                        },{
                                            label: '细目号',
                                            id: 118,
                                        },{
                                            label: '单位',
                                            id: 119,
                                        },{
                                            label: '单价',
                                            id: 120,
                                        },{
                                            label: '是否正式单价',
                                            id: 121,
                                        },{
                                            label: '税率（%）',
                                            id: 122,
                                        },{
                                            label: '中标裸税单价',
                                            id: 123,
                                        },{
                                            label: '数量',
                                            id: 124,
                                        },{
                                            label: '合价',
                                            id: 125,
                                        },{
                                            label: '中标裸税合价',
                                            id: 126,
                                        },{
                                            label: '备注',
                                            id: 127,
                                        },
                                    ]
                                },{
                                    label: '合计',
                                    id: 128,
                                    children: [
                                        {
                                            label: '单价',
                                            id: 129,
                                        },{
                                            label: '合计',
                                            id: 130,
                                        },{
                                            label: '中标裸税合价',
                                            id: 131,
                                        }
                                    ]
                                }
                            ],
                        },{
                            label: '审核状态',
                            id: 132,
                        }
                    ]
                }],
                selectTabList: [],
                isShowTabDialog: false,

                deptList:[], //项目部列表
                projectList:[], //项目列表

                engineerList:[],
                oldengineerList:[],
                listTotal: null,
                actualEngineerList: [],

                multipleSelection: [],

                isFirst: true,
                addVisible: false,  //新增细目
                addBillVisible: false,
                addUnitVisible: false,  //新增合作单位
                submitVisible: false,  //提交审核
                allSubmitVisible: false,
                isShowDataUploadDialog: false,

                btnAuthorize: {
                    export: { key: "export", btnEnable: false },
                    batchSubApproval: { key: "batchSubApproval", btnEnable: false },
                    setTabHiddenVisible: { key: "setTabHiddenVisible", btnEnable: false },
                    deleteDetailedData: { key: "deleteDetailedData", btnEnable: false },
                    importDetailedData: { key: "importDetailedData", btnEnable: false },
                },
                loading: false,
            }
        },
        components:{
            addBill,
            addDetail,
            addUnit,
            dataUploadDialog,
            submitReview,
            allSubmitReview,
            tabShowDialog,
        },
        methods: {
            onActive(menuCode) {
                let selectTabList = []
                for (let i = 0; i< 134; i++){
                    selectTabList.push(i)
                }
                this.selectTabList = selectTabList
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getDeptList();
                if( this.dataForm.projectId){
                    this.initData();
                }
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            queryBtn(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                this.dataForm.pageIndex = 1;
                this.initData();
            },
            /**
             * 查询列表数据
             * */
            initData(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                this.loading = true;
                this.query();
                this.getMiddleListTotal();
            },
            query(){
                let paramsData = {
                    ...this.dataForm
                }
                queryMiddleListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.multipleSelection = [];
                        this.actualEngineerList = res.data;
                        this.engineerList =  inTheSpanMethod(res.data)
                        this.oldengineerList=JSON.parse(JSON.stringify(this.engineerList));
                        this.$forceUpdate();
                        this.$nextTick(()=>{
                            this.loading = false;
                        })
                        this.total =res.total
                        // if(this.isFirst){
                        //     this.$nextTick(()=> {
                        //         this.childHeight4 = this.$refs.dataTable.$el.childNodes[4].offsetHeight - 12 + 'px';
                        //         this.childHeight5 = this.$refs.dataTable.$el.childNodes[5].offsetHeight - 6 + 'px';
                        //         this.$refs.dataTable.$el.childNodes[4].style.height = this.childHeight4
                        //         this.$refs.dataTable.$el.childNodes[5].style.height = this.childHeight5
                        //         this.$refs.dataTable.$el.childNodes[5].style.top = '-6px'
                        //         this.$refs.dataTable.$el.childNodes[5].style.zIndex = '0'
                        //         this.isFirst = false;
                        //     })
                        // }else {
                        //     this.$refs.dataTable.$el.childNodes[4].style.height = this.childHeight4
                        //     this.$refs.dataTable.$el.childNodes[5].style.height = this.childHeight5
                        //     this.$refs.dataTable.$el.childNodes[5].style.top = '-6px'
                        //     this.$refs.dataTable.$el.childNodes[5].style.zIndex = '0'
                        // }
                    }else{
                        this.$message.error(res.msg);
                        this.loading = false;
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                    this.loading = false;
                });
            },
            getMiddleListTotal(){
                let paramsData = {
                    ...this.dataForm
                }
                getMiddleListTotalService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.listTotal = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    approveUserId:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.total = 0;
                this.engineerList = [];
                this.oldengineerList= [];
                this.actualEngineerList = [];
                this.projectList = [];
                this.listTotal = null;
            },
            //选中的值
            // handleSelectionChange(val) {
            //     this.multipleSelection = val;
            // },
            selectCheckOne(val, row) {
              //isSelect true为选中 false 为取消
              let isSelect = val.length && val.indexOf(row) > -1
              //findIndex返回-1则不存在，>0则存在
              let n = this.multipleSelection.findIndex(v => {
                return v.id == row.id
              })
              if (isSelect) {
                if (n < 0) this.multipleSelection.push(row)
              } else {
                if (n > -1) this.multipleSelection = this.multipleSelection.filter(function (obj) {
                  return obj.id !== row.id;
                });
              }
            },
            //全选
            selectAll(arr) {
              //全选先把所有id拿到并去重
              let _arr = [...new Set(arr)]
              this.multipleSelection = _arr
            },
            //新增工程量清单
            handleAddBillClick(item){
                if(item.approveStatusDisplayName == '待审核'){
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                this.addBillVisible = true
                this.$nextTick(() => {
                    this.$refs.addBillDetail.projectId = this.dataForm.projectId;
                    this.$refs.addBillDetail.init()
                })
            },
            //新增细目
            handleAddDetailClick(row, index){
                if(row.approveStatusShow == '待审核'){
                    this.$message.error('事成本已开始审批，不允许更新');
                    return
                }
                // this.handleSaveClick(row, 1,index);
                this.addVisible = true
                this.$nextTick(() => {
                    this.$refs.addDetail.id = row.id;
                    this.$refs.addDetail.titleIndex = index;
                    this.$refs.addDetail.init();
                })
            },
            //删除细目
            handleDeleteClick(row){
                if(row.approveStatusShow == '待审核'){
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                // this.handleSaveClick(row,2)
                this.bus.$emit("navMenuChange", {
                    routeId: "inTheDeleteDetail",
                    routeParam: {
                        id: row.id
                    }
                });
            },
            //暂存
            handleSaveClick(row, noMessage=false, titleIndex = null) {
                if(row.approveStatusShow == '待审核'){
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                let obj = this.actualEngineerList[row.index]
                let params = {
                    ...obj
                }
                params.approveStatusEnum = 'READY'
                params.laborActList = [];
                params.machineActList = [];
                params.materialActList = [];
                params.otherActList = [];
                obj.partyActList.map(item => {
                    params.laborActList = [...params.laborActList,...item.laborActList]
                    params.machineActList = [...params.machineActList,...item.machineActList]
                    params.materialActList = [...params.materialActList,...item.materialActList]
                    params.otherActList = [...params.otherActList,...item.otherActList]
                })
                saveMiddleService(params).then( res => {
                    if(res.code == 10000000){
                        if(!noMessage){
                            this.$message.success('暂存成功');
                            this.initData();
                        }else{
                            if (noMessage == 1) {
                                this.addVisible = true
                                this.$nextTick(() => {
                                    this.$refs.addDetail.id = row.id;
                                    this.$refs.addDetail.titleIndex = titleIndex;
                                    this.$refs.addDetail.init();
                                })
                            }else if (noMessage == 2){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "inTheDeleteDetail",
                                    routeParam: {
                                        id: row.id,
                                        isShowDeleteBtn : this.btnAuthorize.deleteDetailedData.btnEnable
                                    }
                                });
                            }else if (noMessage == 3){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "inTheHistoryEdition",
                                    routeParam: {
                                        id: row.id
                                    }
                                });
                            }else if (noMessage == 4){
                                this.bus.$emit("navMenuChange", {
                                    routeId: "inTheInfoDetails",
                                    routeParam: {
                                        id: row.id,
                                        index: 1,
                                    }
                                });
                            }else if(noMessage == 5) {
                                this.initData();
                            }
                        }
                    }else{
                        if(!noMessage){
                            this.$message.error(res.msg);
                        }
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //批量暂存
            handleAllSaveClick(noMessage = false){
                let params = [];
                this.actualEngineerList.map(item => {
                    if(item.approveStatusShow != '待审核'){
                        item.approveStatusEnum = 'READY'
                        item.laborActList = [];
                        item.machineActList = [];
                        item.materialActList = [];
                        item.otherActList = [];
                        item.partyActList.map(subItem => {
                            item.laborActList = [...item.laborActList,...subItem.laborActList]
                            item.machineActList = [...item.machineActList,...subItem.machineActList]
                            item.materialActList = [...item.materialActList,...subItem.materialActList]
                            item.otherActList = [...item.otherActList,...subItem.otherActList]
                        })
                        params.push(item)
                    }
                })
                saveMiddleBatchService(params).then( res => {
                    if(res.code == 10000000){
                        if(!noMessage){
                            this.$message.success('批量暂存成功（仅对已保存状态和撤回状态的数据暂存）');
                            this.initData();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //提交审核
            handleSubmitClick(item){
                if(item.approveStatusShow == '待审核'){
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                this.submitVisible = true
                this.$nextTick(() => {
                    this.$refs.submitReview.titleIndex = 2;
                    this.$refs.submitReview.id = item.id;
                    this.$refs.submitReview.row = item;
                    this.$refs.submitReview.actualEngineerList = this.actualEngineerList;
                    this.$refs.submitReview.title = item.subCategoryName;
                    this.$refs.submitReview.projectId = this.dataForm.projectId;
                    this.$refs.submitReview.documentNum = item.subCategoryNo;
                    this.$refs.submitReview.init()
                })
            },
            // 显示数据导入弹窗
            handleShowDataUploadDialogClick(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                this.isShowDataUploadDialog = true;
                this.$nextTick(() => {
                    this.$refs.dataUploadDialog.projectId = this.dataForm.projectId;
                    this.$refs.dataUploadDialog.init();
                })
            },
            // 批量删除总包细目
            handleSelectDeleteClick(){
                if(this.multipleSelection.length == 0){
                    this.$message.error('请选择要删除的数据');
                    return
                }
                console.log(this.multipleSelection)
                let index = this.multipleSelection.findIndex(item => item.approveStatusShow == '待审核' || item.approveStatusShow == '已通过')
                if(index != -1){
                  this.$message.error('事中成本已开始审批，不允许删除');
                  return
                }
                this.$confirm('此操作将永久删除该总包细目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = this.multipleSelection.map(item => item.id)
                    let params = {
                        ids: ids
                    }
                    console.log(params)
                    batchDeleteMiddleDataService(params).then(res => {
                        if(res.code == 10000000){
                            this.$message.success('删除成功');
                            this.initData();
                        }
                    })
                }).catch(() => {

                });
            },
            // 批量提交审批
            handleSelectSubmitClick(){
                console.log(this.multipleSelection)
                if(this.multipleSelection.length == 0){
                    this.$message.error('请选择要提交的数据');
                    return
                }
                let index = this.multipleSelection.findIndex(item => item.approveStatusShow == '待审核')
                if(index != -1){
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                // this.handleAllSaveClick(true);
                this.allSubmitVisible = true
                this.$nextTick(() => {
                    this.$refs.allSubmitReview.titleIndex = 2;
                    this.$refs.allSubmitReview.approveItemList = this.multipleSelection;
                    this.$refs.allSubmitReview.actualEngineerList = this.actualEngineerList;
                    this.$refs.allSubmitReview.projectId = this.dataForm.projectId;
                    this.$refs.allSubmitReview.init();
                })
            },
            // 撤回审批流
            handleWithdrawClick(item){
                this.$confirm("确定要撤回吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let params = {
                        itemId : item.id,
                        type: 'PROJECT_MIDDLE'
                    }
                    recallApproveProcessService(params).then( res => {
                        if(res.code == 10000000){
                            this.$message.success('撤回成功');
                            this.query()
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        this.$message.error("网络请求失败");
                    });
                });
            },
            //查看历史版本
            handleHistoryEditionClick(row){
                // if(row.approveStatusShow == '待审核'){
                    this.bus.$emit("navMenuChange", {
                        routeId: "inTheHistoryEdition",
                        routeParam: {
                            id: row.id
                        }
                    });
                // }else{
                //     this.handleSaveClick(row,3)
                // }
            },
            //查看详情
            handleInfoDetailsClick(row){
                // if(row.approveStatusShow == '待审核'){
                    this.bus.$emit("navMenuChange", {
                        routeId: "inTheInfoDetails",
                        routeParam: {
                            id: row.id,
                            index: 1,
                        }
                    });
                // }else{
                //     this.handleSaveClick(row,4)
                // }
            },
            /***
             * 导出
             */
            exportBtn(){
                if(!this.dataForm.projectId){
                    this.$message.error('请先选择项目名称后再导出！');
                    return
                }
                let loading = Loading.service({
                    lock: true,
                    text: "加载中",
                    background: "rgba(0, 0, 0, 0.5)"
                });
                let params = {
                    ...this.dataForm,
                }
                exportMiddleService(params).then( res => {
                    loading.close();
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    loading.close();
                    this.$message.error("网络请求失败");
                });
            },

            setTabDialogBtn(){
                this.isShowTabDialog = true;
                this.$nextTick(()=> {
                    this.$refs.tabShowDialog.tabDataList = this.tabDataList;
                    this.$refs.tabShowDialog.selectTabList = this.selectTabList;
                    this.$refs.tabShowDialog.init();
                })
            },
            setSelectTabList(val){
                this.selectTabList = val;
                this.isShowTabDialog = false;
                this.reset();
                this.$nextTick(() => {
                    this.$refs.dataTable.$el.childNodes[2].style.height = this.$refs.dataTable.$el.childNodes - ( this.$refs.dataTable.$el.childNodes[1].clientHeight || this.$refs.dataTable.$el.childNodes[1].offsetHeight) + 'px'
                    this.$refs.dataTable.doLayout();
                })
            },
            uploadData(){
                this.isShowDataUploadDialog = false;
                this.queryBtn();
            },
            //设置数值
            setValue(item,type,name){
                let oldData=this.oldengineerList.filter(em=>(em.index==item.index&&em.subIndex==item.subIndex))||[]
                if(oldData.length>0&&item[name]== oldData[0][name])
                {
                    // this.$message.error('数据没有变化');
                    return
                }
                if(item.approveStatusShow == '待审核'){
                    item[name]=  oldData[0][name]
                    this.$message.error('事中成本已开始审批，不允许更新');
                    return
                }
                this.actualEngineerList =  inTheModifyValue(this.actualEngineerList, item, type)
                this.engineerList =  inTheSpanMethod(this.actualEngineerList)
                this.$nextTick(()=> {
                    this.loading = true;
                    this.handleSaveClick(item, 5)
                })
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.initData();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.initData();
            },
            //合并表格条件
            spanArrayMethod({row,column,rowIndex,columnIndex}) {
                if(column.type == 'selection' || column.property == 'subCategoryName'|| column.property == 'subCategoryNo'
                    || column.property == 'deptName'|| column.property == 'unit'|| column.property == 'unitPrice'
                    || column.property == 'unitPriceTypeBool'|| column.property == 'contractCount'|| column.property == 'contractSumPrice'
                    || column.property == 'checkCount'|| column.property == 'checkSumPrice'|| column.property == 'expectCount'
                    || column.property == 'expectSumPrice'|| column.property == 'actFinishCount'|| column.property == 'actFinishSumPrice'
                    || column.property == 'expectFinishCount'|| column.property == 'expectFinishSumPrice'

                    || column.property == 'unit_Price'|| column.property == 'total_Price'|| column.property == 'bidSum_Price'

                    || column.property == 'approveStatusShow'|| column.property == 'operation'
                    || column.property == 'totalUnitPrice'|| column.property == 'totalUnitSumPrice'|| column.property == 'totalBidSumPrice'){
                    const _row = (getJBXXTableData(this.engineerList).one)[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
                // if (columnIndex <= 15 || columnIndex >= 116 || (columnIndex >= 61 && columnIndex <= 63)) {
                //     const _row = (getJBXXTableData(this.engineerList).one)[rowIndex];
                //     const _col = _row > 0 ? 1 : 0;
                //     return {
                //         rowspan: _row,
                //         colspan: _col
                //     };
                // }

                if(column.property == 'partyBName'
                    // || column.property == 'party_unitPrice'|| column.property == 'party_unitSumPrice'|| column.property == 'party_bidSumPrice'
                ){
                    const _row = (getJBXXTableData(this.engineerList).two)[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
                // if (columnIndex === 64 ||columnIndex === 76 || columnIndex === 89 || columnIndex === 101 ||
                //     columnIndex === 113 || columnIndex === 114 || columnIndex === 115 ) {
                //     const _row = (getJBXXTableData(this.engineerList).two)[rowIndex];
                //     const _col = _row > 0 ? 1 : 0;
                //     return {
                //         rowspan: _row,
                //         colspan: _col
                //     };
                // }
            },

        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        /deep/.engineeringForm {
            .el-form-item{
                margin-top: 5px;
            }
        }
        .operatePanel{
            margin-top: 5px !important;
            .el-button{
                margin-bottom: 10px;
            }
        }
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
    /deep/.el-table{
        th>.cell{
            text-align: center;
        }
        .cell.el-tooltip{
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
        }
    }
    .statisticsList{
        display: flex;
        border: 1px solid #E6E6E6;
        .statisticsItem {
            width: 12%;
            .statisticsTxt {
                width: 100%;
                height: 36px;
                line-height: 36px;
                text-align: center;
                border-right: 1px solid #E6E6E6;
                border-bottom: 1px solid #E6E6E6;
                font-size: 12px;
            }
            .statisticsNum {
                width: 100%;
                height: 36px;
                line-height: 36px;
                text-align: center;
                border-right: 1px solid #E6E6E6;
            }
        }
    }
    /*/deep/.bueatyScroll .el-table__body-wrapper{*/
    /*    position: relative;*/
    /*}*/
    /deep/.bueatyScroll {
        .el-table__body-wrapper{
          height: calc(100% - 114px) !important;
        }
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-scrollbar__wrap::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;
        }
        .el-table__fixed{
            height: calc(100% - 12px) !important;
        }
        .el-table__fixed-right{
            height: calc(100% - 12px) !important;
        }
    }
</style>
